// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { $delete, update, createOrUpdate, get, list } from "./operations.js";
export {
  PlacementPoliciesDeleteOptionalParams,
  PlacementPoliciesUpdateOptionalParams,
  PlacementPoliciesCreateOrUpdateOptionalParams,
  PlacementPoliciesGetOptionalParams,
  PlacementPoliciesListOptionalParams,
} from "./options.js";
